export default __webpack_public_path__ + "static/media/profile.b09f56d2.png";